module.exports = __webpack_public_path__ + "static/media/Membership-card.badf1ef3.png";